import { BackButton } from "../../../primaryComponents";
import { ProgressSection } from "./ProgressSection";
import globalStyles from "../../../../assets/styles/base/globalPage.module.scss";
import styles from "./styles.module.scss";
import { ConnectorIcon, LumiSecondaryIcon } from "../../../../assets/svgIcons";
import { ConnectTerminal } from "./ConnectTerminal";
import { ConnectBusiness } from "./ConnectBusiness";
import { ConnectPublicKeys } from "./ConnectPublicKeys";
import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { intergratedTerminalInfo } from "../../../../localdata/intergratedTerminalInfo";

const forms = {
  ConnectTerminal,
  ConnectBusiness,
  ConnectPublicKeys,
};

export const IntegratedTerminalForm = ({
  isEditMode = false,
  terminalDetails = {},
  businessAccountDetails = {},
  terminalType = "",
}) => {
  const navigate = useNavigate();
  const [search] = useSearchParams();
  const isUpdateBusinessOnly = search.get("business_only");
  const providerprops = intergratedTerminalInfo?.[terminalType];
  const [step, setStep] = useState(
    isUpdateBusinessOnly ? 0 : providerprops?.fields?.length - 1,
  );

  return (
    <div className={globalStyles.pageColumnGaps}>
      <div>
        <BackButton
          onClick={() => {
            if (step > 0) return setStep((prev) => prev - 1);

            navigate(-1);
          }}
        />
      </div>

      {providerprops?.fields?.length > 1 && (
        <ProgressSection
          step={step}
          setStep={setStep}
          stepList={providerprops?.fields?.map((item) => {
            return {
              id: item?.step,
              title: item?.label,
            };
          })}
        />
      )}

      <div className={`${globalStyles.cardWithBackground} white p-0 mt-4`}>
        <div className={styles.header}>
          <div>
            <h5 className="mb-0">Connect Business</h5>
            <p>
              Enter your terminal and merchant details to link your business and
              enable syncing of transactions.
            </p>
          </div>

          <div className="d-flex align-items-center" style={{ gap: "10px" }}>
            {providerprops?.icon}
            <ConnectorIcon />
            <LumiSecondaryIcon />
          </div>
        </div>

        <div className={styles.body}>
          <div className={styles.body__form}>
            {providerprops?.fields?.map((item, index) => {
              if (index === step) {
                const FormType = forms?.[item?.name];

                return (
                  <React.Fragment key={index}>
                    <FormType
                      fieldProps={item}
                      providerprops={providerprops}
                      terminalType={terminalType}
                      terminalDetails={terminalDetails}
                      isEditMode={isEditMode}
                      businessAccountDetails={businessAccountDetails}
                      step={step}
                      setStep={setStep}
                    />
                  </React.Fragment>
                );
              }
              return null;
            })}
          </div>
        </div>
      </div>

      {/* <FixedbottomButtonCover style={{ flexWrap: "wrap" }}>
        <div
          className="d-flex ml-auto"
          style={{ gap: "5px", width: "100%", maxWidth: "405px" }}
        >
           {hasBusinessDetails && step === 0 ? (
            <primaryComponents.Button
              classNames={`btn ${isUpdateBusinessOnly ? "btn--primary" : "btn--outline"} cover`}
              type="button"
              isDisabled={isLoading}
              isLoading={isLoading}
              loadingText={"Updating..."}
              onClick={handleSubmit(proceedToNext)}
            >
              Update
            </primaryComponents.Button>
          ) : null} 

           <primaryComponents.Button
            classNames={"btn btn--primary cover ml-auto"}
            style={{ maxWidth: "200px" }}
            id={}
            type="button"
            // isDisabled={isLoading}
            // isLoading={isLoading}
            loadingText={"Processing..."}
            // onClick={handleSubmit(() => proceedToNext(false))}
          >
            <ArrowCircleIcon className="mr-1" />
            {hasBusinessDetails && step === 0 ? (
              <>Next</>
            ) : (
              <>{isEditMode ? "Update" : "Proceed"}</>
            )}
          </primaryComponents.Button> 
        </div>
      </FixedbottomButtonCover> */}
    </div>
  );
};
